import { Navbar } from "./navbar";
import chercher from "../photo/chercher.png";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { ChercherButton } from "./slice";
import ImageHome from "../photo/ImageHome.png";
import { ListeClimatisseurs } from "./listeClimatisseurs";
import { ListeProjets } from "./listeProjets";
import { Contact } from "./contact";
import "../styles/home.css";

export function Home() {
    const [Recherche, setRecherche] = useState("");
    const dispatch = useDispatch();

    return (
        <div className="home-page">
            <Navbar />
            <div className="hero-container">
                <div className="hero-left">
                    <div className="search-container">
                        <div className="search-wrapper">
                            <input
                                type="text"
                                onChange={(e) => setRecherche(e.target.value)}
                                value={Recherche}
                                placeholder="chercher..."
                            />
                            <button className="search-icon-btn" onClick={() => {
                                 dispatch(ChercherButton(Recherche));
                             }}>
                                <img src={chercher} alt="search" />
                            </button>
                        </div>
                    </div>

                    <h1 className="hero-title">
                        Jamas lens Specialistes <br />
                        en climatisation et projets de <br />
                        construction
                    </h1>

                    <p className="hero-subtitle">
                        Nous vendons tous types de climatiseurs et réalisons des projets de construction publique.
                    </p>
                </div>

                <div className="hero-right">
                    <img src={ImageHome} alt="Climatiseurs" className="hero-image" />
                </div>
            </div>

            <ListeClimatisseurs isHome={true} />
            <ListeProjets isHome={true} />
            <Contact />
        </div>
    );
};